// removed by extract-text-webpack-plugin
module.exports = {"review":"_3X6Da","photo":"ySU9H","details":"_1lLNQ","reviewerName":"_3LjiF","reviewerTitle":"u6kfZ","reviewText":"_1_L38","showOnMobile":"soWvT","showOnDesktop":"_1XiwM","ratingBadge":"_2qRxK"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/ProductReview/index.sass
// module id = 1499
// module chunks = 1